export const LEFT_MENU_ACTIONS_OPEN = 'LEFT_MENU_ACTIONS_OPEN';
export const LEFT_MENU_ACTIONS_CLOSE = 'LEFT_MENU_ACTIONS_CLOSE';

export interface LeftMenuOpen {
  type: typeof LEFT_MENU_ACTIONS_OPEN;
  payload: boolean;
}

export interface LeftMenuClose {
  type: typeof LEFT_MENU_ACTIONS_CLOSE;
  payload: boolean;
}

export type LeftMenuActionTypes = LeftMenuOpen | LeftMenuClose;
